"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { SectionKey } from "@/themes/types";

type SectionMap = Record<SectionKey, string>;

const ThemeVariantContext = createContext<SectionMap | null>(null);

export function ThemeVariantProvider({ sections, children }: { sections: SectionMap; children: ReactNode }) {
  return <ThemeVariantContext.Provider value={sections}>{children}</ThemeVariantContext.Provider>;
}

export function useSectionVariant(key: SectionKey, fallback: string): string {
  const ctx = useContext(ThemeVariantContext);
  return ctx?.[key] ?? fallback;
}
